<template>
  <div class="comment-input" data-cx-clickarea="comment-input" ref="commentInput">
    <div class="comment-input__inner" v-if="isYellow">
      <div class="non-login">
        <p class="text">{{user.warning}}</p>
      </div>
    </div>
    <div class="comment-input__inner" v-if="isLogin">
      <div class="comment-input__header">
        <user-info :userData="user"></user-info>
      </div>

      <!-- コメント本文 入力 -->
      <div class="comment-input__body" v-if="isEdit">
        <textarea
          class="textarea"
          :class="{ 'textarea--error': isError }"
          placeholder="コメントを入力してください。"
          v-model="comment"
          v-on:keyup="autoResize"
          :style="textStyle"
          ref="inputElm"
        ></textarea>
        <div
          class="textarea__count"
          :class="{ 'textarea__count--error': isError }"
        >{{commentLength}}/{{postCommentMax}}</div>
      </div>

      <!-- コメント本文 確認 -->
      <div class="comment-input__body" v-else>
        <p class="comment-input__check" v-text="comment"></p>
      </div>

      <div class="comment-input__footer">
        <a
          href="https://www.j-cast.com/etc/comment_guide.html"
          class="text-link"
          target="_blank"
        >コメントガイドライン</a>

        <!-- コメント操作ボタン 入力 -->
        <div class="comment-input-btn-group" v-if="isEdit">
          <button
            class="btn btn-has-bg btn-check"
            type="button"
            :disabled="this.isBtnDisabled"
            @click="check"
          >
            <span class="btn-text">確認</span>
          </button>
        </div>

        <!-- コメント操作ボタン 確認 -->
        <div class="comment-input-btn-group" v-else>
          <button class="btn btn-edit" type="button" @click="editHandler">
            <span class="btn-text">編集</span>
          </button>
          <button
            class="btn btn-has-bg btn-submit"
            type="button"
            @click="submit"
            :disabled="postDisabled"
          >
            <span class="btn-text">投稿</span>
          </button>
        </div>
      </div>
    </div>
    <before-login-comment-input-reply v-else-if="replyKey" :replyKey="replyKey" :user="user" />
    <before-login-comment-input v-else :user="user" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import userInfo from '../../molecules/userInfo/userInfo'
import beforeLoginCommentInput from '../beforeLoginCommentInput'
import beforeLoginCommentInputReply from '../beforeLoginCommentInput/reply'
export default {
  name: 'commentInput',
  props: {
    replyKey: String,
    i: Number
  },
  data: function () {
    const data = {
      textStyle: {},
      layer: 'edit',
      edit: true,
      postComment: '',
      postCommentMax: 400,
      editableCommentLength: 0,
      editablePostComment: '',
      postDisabled: false
    }

    return data
  },
  mounted () {
    this.$nextTick(() => {
      if (this.replyKey) {
        try {
          const reply = localStorage.getItem(`before_reply_${this.replyKey}`)

          if (reply) {
            const replyData = JSON.parse(reply)
            if (replyData.expired_at > new Date().getTime()) {
              const el = this.$refs.commentInput
              setTimeout(() => {
                const pos = el.getBoundingClientRect().top - 200
                this.$SmoothScroll(pos, 250)
              }, 300)
              this.postComment = replyData.comment
              this.edit = false
            } else {
              localStorage.removeItem(`before_reply_${this.replyKey}`)
            }
          }
        } catch (e) {
          return false
        }
      } else {
        try {
          const comment = localStorage.getItem(`before_${this.entryID}`)
          if (comment) {
            const commentData = JSON.parse(comment)
            if (commentData.expired_at > new Date().getTime()) {
              this.postComment = commentData.comment
              this.edit = false
              const el = this.$refs.commentInput
              setTimeout(() => {
                const pos = el.getBoundingClientRect().top - 200
                this.$SmoothScroll(pos, 250)
              }, 300)
            } else {
              localStorage.removeItem(`before_${this.entryID}`)
            }
          }
        } catch (e) {
          return false
        }
      }
    })
  },
  components: {
    'user-info': userInfo,
    'before-login-comment-input': beforeLoginCommentInput,
    'before-login-comment-input-reply': beforeLoginCommentInputReply
  },
  computed: {
    ...mapState('commentsData', ['entryID']),
    ...mapState('userData', ['user']),
    comment: {
      get () {
        return this.postComment
      },
      set (val) {
        this.postComment = val
          .replace(/(\r\n)|\n/g, '<br>')
          .replace(/(<br>){2,}/g, '<br><br>')
          .replace(/\s+/g, ' ')
          .replace(/<br>/g, '\n')
      }
    },
    commentLength: function () {
      return this.comment.length
    },
    isYellow () {
      return this.user && this.user.yellowFlag && this.user.yellowFlag > 1
    },
    isLogin () {
      console.log('login', (
        (this.user && this.user.role) &&
        (this.user.role === 'low' || this.user.role === 'middle') &&
        (this.user.yellowFlag === undefined || this.user.yellowFlag === 1)
      ))
      return (
        (this.user && this.user.role) &&
        (this.user.role === 'low' || this.user.role === 'middle') &&
        (this.user.yellowFlag === undefined || this.user.yellowFlag === 1)
      )
    },
    isBtnDisabled: function () {
      // コメント数が0以上max以下 true
      const count = this.postComment.length
      const isCheckBtnDisabled = !(count > 0 && count < this.postCommentMax)
      return isCheckBtnDisabled
    },
    isError: function () {
      // コメント数がmax以上
      const count = this.postComment.length
      return count > this.postCommentMax
    },
    isEdit () {
      return this.edit
    }
  },
  methods: {
    ...mapActions('commentsData', ['commentSubmit']),
    ...mapActions('modal', ['siteloginModal', 'siteRankupModal']),
    check: function () {
      // layer変更
      if (this.isError) {
        return
      }
      this.layer = 'check'
      this.edit = false
    },
    editHandler: function () {
      this.layer = 'edit'
      this.edit = true
      this.$nextTick(function () {
        this.autoResize({ target: this.$refs.inputElm })
      })
    },
    submit: function () {
      // 投稿するコメントは、主か返信かを replyPostFlagで判定
      const payload = {
        entry_id: this.entryID,
        postComment: this.postComment,
        replyKey: this.replyKey,
        replyPostFlag: this.replyKey !== undefined,
        i: this.i
      }
      // 処理中はdisabled
      this.postDisabled = true
      // 通信を待って処理
      this.commentSubmit(payload).then(
        function (isPostSuccess) {
          // console.log('postからの戻り', isPostSuccess)
          // 戻りあれば無条件でdisabled解除

          this.postDisabled = false
          if (isPostSuccess) {
            // 成功
            if (this.replyKey) {
              localStorage.removeItem(`before_reply_${this.replyKey}`)
            } else {
              localStorage.removeItem(`before_${this.entryID}`)
            }
            this.layer = 'edit'
            this.edit = true
            this.postComment = ''
          } else {
            // 失敗
            this.layer = 'edit'
            this.edit = true
          }
        }.bind(this)
      )
    },

    // テキストエリア自動調整
    // 参考：https://qiita.com/YoshiyukiKato/items/507b8022e6df5e996a59
    autoResize () {
      const el = this.$refs.inputElm
      const style = { lineHeight: '22px' }
      if (el.scrollHeight > el.offsetHeight) {
        style.height = el.scrollHeight + 'px'
      } else {
        style.height = el.scrollHeight + 'px'
        if (el.scrollHeight > el.offsetHeight) {
          style.height = el.scrollHeight + 'px'
        }
      }
      if (this.commentLength < 1) {
        style.height = 'auto'
      }
      this.textStyle = style
    },

    // コメント書き込むボタン
    commentWrite () {
      // ロール判定
      if (this.user.role === 'low' || this.user.idOnly) {
        this.siteRankupModal('newsComment')
      } else {
        this.siteloginModal('newsComment')
      }
    }
  }
}
</script>

<style lang="scss" src="./commentInput.scss"></style>



// WEBPACK FOOTER //
// src/components/organisms/commentInput/commentInput.vue